import { NemsisCodes } from '../../../common/nemsisCodes.constants'
import { DestinationAddressConstants } from './destinationAddress.constants'
import { IDestinationAddressState, IDispositionAction, IDispositionState } from './destinationAddress.types'

export const initialDestinationAddressState: IDestinationAddressState = {
  type: 2,
  txToCode: null,
  name: '',
  commonAddress: null,
  addressLine1: '',
  addressLine2: '',
  aptSuiteRoom: '',
  milePostMajorRoadway: '',
  crossStreetDirections: '',
  city: null,
  state: null,
  zip: '',
  county: null,
  country: null,
  censusTract: '',
  usng: '',
  gpsn: '',
  gpse: '',
  grid: null,
  stateIds: null,
  __areDefaultsSet: false,
}

export const initialDispostionState: IDispositionState = {
  typeValue: null,
  hospitalInPatientDestination: null,
  hospitalCapability: [],
  hospitalCapabilityPNNV: null,
  receivingNurse: '',
  receivingMdText: '',
  transportModeFromScene: null,
  transportModeFromScenePNNV: null,
  addlTransportModeDescriptors: [],
  addlTransportModeDescriptorsPNNV: null,
  reasonForChoosingDestination: [],
  reasonForChoosingDestinationPNNV: null,
  comment: '',
  destination: initialDestinationAddressState,
}

export function destinationAddressReducer(
  state: IDispositionState = initialDispostionState,
  action: IDispositionAction
): IDispositionState {
  switch (action.type) {
    case DestinationAddressConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case DestinationAddressConstants.SET_TYPE:
      return { ...state, typeValue: action.typeValue }
    case DestinationAddressConstants.SET_OTHER_TYPE:
      return {
        ...state,
        destination: {
          ...state.destination,
          txToCode: action.txToCode,
        },
      }
    case DestinationAddressConstants.SET_HOSPITAL_IN_PATIENT_DESTINATION:
      return { ...state, hospitalInPatientDestination: action.hospitalInPatientDestination }
    case DestinationAddressConstants.SET_MODE_DESCRIPTORS:
      return {
        ...state,
        addlTransportModeDescriptors: action.addlTransportModeDescriptors,
      }
    case DestinationAddressConstants.SET_MODE_DESCRIPTORS_PNNV:
      return {
        ...state,
        addlTransportModeDescriptorsPNNV: action.addlTransportModeDescriptorsPNNV,
      }
    case DestinationAddressConstants.SET_DESTINATION_GRID:
      return {
        ...state,
        destination: {
          ...state.destination,
          grid: action.grid,
        },
      }
    case DestinationAddressConstants.SET_DESTINATION_BASIS:
      return { ...state, reasonForChoosingDestination: action.reasonForChoosingDestination }
    case DestinationAddressConstants.SET_DESTINATION_BASIS_PNNV:
      return { ...state, reasonForChoosingDestinationPNNV: action.reasonForChoosingDestinationPNNV }
    case DestinationAddressConstants.SET_LOCATION:
      return {
        ...state,
        destination: {
          ...state.destination,
          name: action.name,
        },
      }
    case DestinationAddressConstants.SET_ADDRESS_LINE1:
      return {
        ...state,
        destination: {
          ...state.destination,
          addressLine1: action.addressLine1,
        },
      }
    case DestinationAddressConstants.SET_ADDRESS_LINE2:
      return {
        ...state,
        destination: {
          ...state.destination,
          addressLine2: action.addressLine2,
        },
      }

    case DestinationAddressConstants.SET_APT_SUITE_ROOM:
      return {
        ...state,
        destination: {
          ...state.destination,
          aptSuiteRoom: action.aptSuiteRoom,
        },
      }
    case DestinationAddressConstants.SET_MILE_POST_MAJOR_ROADWAY:
      return {
        ...state,
        destination: {
          ...state.destination,
          milePostMajorRoadway: action.milePostMajorRoadway,
        },
      }
    case DestinationAddressConstants.SET_CROSS_STREET_DIRECTIONS:
      return {
        ...state,
        destination: {
          ...state.destination,
          crossStreetDirections: action.crossStreetDirections,
        },
      }
    case DestinationAddressConstants.SET_CITY:
      return {
        ...state,
        destination: {
          ...state.destination,
          city: action.city,
        },
      }
    case DestinationAddressConstants.SET_STATE:
      return {
        ...state,
        destination: {
          ...state.destination,
          state: action.state,
        },
      }
    case DestinationAddressConstants.SET_COUNTY:
      return {
        ...state,
        destination: {
          ...state.destination,
          county: action.county,
        },
      }
    case DestinationAddressConstants.SET_ZIP:
      return {
        ...state,
        destination: {
          ...state.destination,
          zip: action.zip,
        },
      }
    case DestinationAddressConstants.SET_COUNTRY:
      return {
        ...state,
        destination: {
          ...state.destination,
          country: action.country,
        },
      }
    case DestinationAddressConstants.SET_CENSUS_TRACT:
      return {
        ...state,
        destination: {
          ...state.destination,
          censusTract: action.censusTract,
        },
      }
    case DestinationAddressConstants.SET_STATE_IDS:
      return {
        ...state,
        destination: {
          ...state.destination,
          stateIds: action.stateIds,
        },
      }
    case DestinationAddressConstants.SET_RECEIVING_RN:
      return { ...state, receivingNurse: action.receivingNurse }
    case DestinationAddressConstants.SET_RECEIVING_MD:
      return { ...state, receivingMdText: action.receivingMdText }
    case DestinationAddressConstants.SET_RECEIVING_USNG:
      return {
        ...state,
        destination: {
          ...state.destination,
          usng: action.usng,
        },
      }
    case DestinationAddressConstants.SET_RECEIVING_GPS_N:
      return {
        ...state,
        destination: {
          ...state.destination,
          gpsn: action.gpsn,
        },
      }
    case DestinationAddressConstants.SET_RECEIVING_GPS_E:
      return {
        ...state,
        destination: {
          ...state.destination,
          gpse: action.gpse,
        },
      }
    case DestinationAddressConstants.SET_COMMON_ADDRESS:
      return {
        ...state,
        destination: {
          ...state.destination,
          commonAddress: action.commonAddress,
        },
      }
    case DestinationAddressConstants.SET_COMMENT:
      return {
        ...state,
        comment: action.comment,
      }
    case DestinationAddressConstants.SET_CAPABILITIES:
      return {
        ...state,
        hospitalCapability: action.hospitalCapability,
      }
    case DestinationAddressConstants.SET_CAPABILITIES_PNNV:
      return {
        ...state,
        hospitalCapabilityPNNV: action.hospitalCapabilityPNNV,
      }
    case DestinationAddressConstants.SET_TRANSPORT_MODE:
      return { ...state, transportModeFromScene: action.transportModeFromScene }
    case DestinationAddressConstants.SET_TRANSPORT_MODE_PNNV:
      return { ...state, transportModeFromScenePNNV: action.transportModeFromScenePNNV }
    case DestinationAddressConstants.SET_DESTINATION_ADDRESS_DEFAULTS:
      return {
        ...state,
        destination: {
          ...state.destination,
          __areDefaultsSet: action.__areDefaultsSet,
        },
      }
    case DestinationAddressConstants.SET_DISPOSITION_STATE:
      return { ...state, ...action.disposition }
    case DestinationAddressConstants.RESET_DISPOSITION_STATE:
      return {
        typeValue: {
          id: 2,
          name: 'Hospital',
        },
        hospitalInPatientDestination: null,
        hospitalCapability: [],
        hospitalCapabilityPNNV: null,
        receivingNurse: '',
        receivingMdText: '',
        transportModeFromScene: null,
        transportModeFromScenePNNV: null,
        addlTransportModeDescriptors: [],
        addlTransportModeDescriptorsPNNV: null,
        reasonForChoosingDestination: [],
        reasonForChoosingDestinationPNNV: null,
        comment: '',
        destination: {
          type: 2,
          txToCode: null,
          name: '',
          commonAddress: null,
          addressLine1: '',
          addressLine2: '',
          aptSuiteRoom: '',
          milePostMajorRoadway: '',
          crossStreetDirections: '',
          city: null,
          state: null,
          zip: '',
          county: null,
          country: null,
          censusTract: '',
          usng: '',
          gpsn: '',
          gpse: '',
          grid: null,
          stateIds: null,
          __areDefaultsSet: false,
        },
      }
    case DestinationAddressConstants.RESET_DESTINATION_ADDRESS_STATE_ON_TYPE_CHANGE:
      return {
        ...state,
        hospitalInPatientDestination: null,
        hospitalCapability: [],
        receivingNurse: '',
        receivingMdText: '',
        transportModeFromScene: null,
        transportModeFromScenePNNV: null,
        addlTransportModeDescriptors: [],
        addlTransportModeDescriptorsPNNV: null,
        reasonForChoosingDestination: [],
        reasonForChoosingDestinationPNNV: null,
        comment: '',
        destination: {
          type: 2,
          txToCode: null,
          name: '',
          commonAddress: null,
          addressLine1: '',
          addressLine2: '',
          aptSuiteRoom: '',
          milePostMajorRoadway: '',
          crossStreetDirections: '',
          city: null,
          state: null,
          zip: '',
          county: null,
          country: null,
          censusTract: '',
          usng: '',
          gpsn: '',
          gpse: '',
          grid: null,
          stateIds: null,
          __areDefaultsSet: false,
        },
      }
    case DestinationAddressConstants.SET_DEFAULT_HOSPITAL_CODE:
      return {
        ...state,
        destination: {
          ...state.destination,
          txToCode: { nemsisCodeRec: NemsisCodes.HOSPITAL_NON_EMERGENCY_DEPARTMENT_BED as number },
        },
      }
    case DestinationAddressConstants.SET_DEFAULT_EMS_CODE:
      return {
        ...state,
        destination: {
          ...state.destination,
          txToCode: { nemsisCodeRec: NemsisCodes.EMS_GROUND_DEFAULT as number },
        },
      }
    default:
      return state
  }
}
